import React, {FC} from 'react';

import {Trans} from '../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {PaletteColorsEnum} from '../../../../../../libs/shared/core/src/models/api/paletteModel';
import {OkCancelDialog} from '../../../../../../libs/shared/ui/src/components/dialogs/okCancelDialog';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {useWorkspacesEditor} from '../context/workspacesEditorContext';

/*
 * Component.
 */

export const WorkspacesSaveErrorDialog: FC = () => {
  const {onDismissDialog} = useWorkspacesEditor();

  return (
    <OkCancelDialog
      title={<Trans id="workspaces-saveerror-dialog-title">Something went wrong</Trans>}
      titleIcon={<Icon name="warningFilledSmall" color={PaletteColorsEnum.RED} />}
      onOkClick={onDismissDialog}
      isCancelHidden
    >
      <Trans id="workspaces-saveerror-dialog-tryagain">
        Unfortunately, there was a problem and we weren’t able to save your changes. You can try again or
        leave “Edit sidebar” and return later.
      </Trans>
    </OkCancelDialog>
  );
};
